import { DataManager } from 'utils/DataManager/dataManager';
import { IEmployeeComparisonResults, IEmailIssues } from 'typings/diagnostics';
import { IDiagnosticsManager } from 'typings/dataManagers';
import { DataState } from 'typings/enums';

class DiagnosticsManager extends DataManager implements IDiagnosticsManager {

    compareEmployees(masterAccountId: string): Promise<Nullable<IEmployeeComparisonResults>> {
        const receive = () => this._getDataRequest<IEmployeeComparisonResults>(
            `/${masterAccountId}/diagnostics/employees/compare`);
        return this.getData<IEmployeeComparisonResults>(receive, false);
    }

    getEmailIssues(masterAccountId: string): Promise<Nullable<IEmailIssues>> {
        const receive = () => this._getDataRequest<IEmailIssues>(
            `/${masterAccountId}/emails`);
        return this.getData<IEmailIssues>(receive, false);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }
}

export { DiagnosticsManager };
export default DiagnosticsManager;